import React from 'react';
import { RouterProvider } from 'react-router-dom';
import './App.css';
import { MessageProvider } from './shared/lib/use-message';
import { MessageToast } from './shared/ui/message-toast';
import { Router } from './app/router/Router';

const App = () => {
  return (
    <div className="App">
      <MessageProvider>
        <RouterProvider router={Router} />
        <MessageToast />
      </MessageProvider>
    </div>
  );
};

export default App;
